module.exports = __webpack_public_path__ + "static/media/contactlessWhite.6b403686.png";